

























import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { convertVttToJson } from './helper/vttToJson';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { UserConfModule } from '@/store/modules/userConf';
const UserConfState = getModule(UserConfModule, store);

@Component
export default class AudioPlayer extends Vue {
   public $refs!: {
    scrollList: HTMLElement;
  };
  @Prop({ type: String, required: true }) src!: string;
  @Prop({ type: String }) vttSrc!: string;
  @Prop({ type: String }) cover!: string;
  @Prop({ default: true }) autoplay!: boolean;

  showTranscriptOptions: boolean = false;
  autoscroll: boolean = true;
  unsuportedMessage!: string;
  audio!: HTMLAudioElement | undefined;
  isLoading:boolean = true;
  isPlaying:boolean = false;
  currentTime:number = 0;
  totalTime:number = 0;
  parsedTranscripted: any = [];
  completeSaved:boolean = false;
  isInteractive :boolean = true;

  mounted(){
    this.audio = new Audio(this.src);
    this.audio.addEventListener('canplaythrough', this.audioLoaded);
    this.audio.addEventListener('playing', this.handlePlay);
    this.audio.addEventListener('pause', this.handleStop);
    this.audio.addEventListener('end', this.handleStop);
    this.audio.addEventListener('timeupdate', this.timeUpdate);
    if(this.vttSrc)
      this.parseVtt(this.vttSrc);
    this.audio.load();
  }
  audioLoaded (){
    this.isLoading = false;
    if(this.audio)
      this.totalTime = this.audio.duration;
    
    if(this.autoplay)
      this.play();
    
    this.$emit('audioLoaded');
  }
  beforeDestroy(){
    if(this.audio){
      this.audio.pause();
      this.audio.removeEventListener('canplaythrough', this.audioLoaded);
      this.audio.removeEventListener('playing', this.handlePlay);
      this.audio.removeEventListener('pause', this.handleStop);
      this.audio.removeEventListener('end', this.handleStop);
      this.audio.removeEventListener('timeupdate', this.timeUpdate);
    }
    delete this.audio;
  }
  play(){
    if(this.audio) this.audio.play();
  }
  pause(){
    if(this.audio) this.audio.pause();
  }
  handlePlay(){
    this.isPlaying = true;
  }
  handleStop(){
    this.isPlaying = false;
  }
  timeUpdate(e:Event){
    if(!this.audio) return;
    this.currentTime = this.audio.currentTime;
    if (this.$refs.scrollList && this.autoscroll) {
      const current = this.$refs.scrollList.getElementsByClassName(
        'active'
      )[0];
      this.addSmoothScrollBehavior(current);
    }
    const watched95percent =
      this.currentTime > this.totalTime * 0.95;
    this.emitFinishingEvents(watched95percent);
  }
  emitFinishingEvents(hasWatchedUntilTheEnd: boolean) {
    if (hasWatchedUntilTheEnd && !this.completeSaved) {
      this.$emit('completed');
      this.completeSaved = true;
    }
  }
  addSmoothScrollBehavior(current: any) {
    if (current) 
      current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    
  }

  async parseVtt(vtt_path:string){
    let vttString = await axios.get(vtt_path);
    this.parsedTranscripted = convertVttToJson(vttString.data);
  }

  seek(e:any){
    if(!this.audio) return; 
    let percentage = (e.clientX - e.target.getBoundingClientRect().left) / e.target.offsetWidth;
    this.audio.currentTime = this.totalTime * percentage;
  }
  get time(){
    return this.formatTime(this.currentTime);
  }
  formatTime(totalSeconds:number){
    if(typeof totalSeconds !== 'number' || totalSeconds < 0)
      return '00:00';
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor(totalSeconds / 60) % 60;
    var seconds = Math.floor(totalSeconds % 60);

    return [hours,minutes,seconds]
      .map(v => v < 10 ? '0' + v : v)
      .filter((v,i) => v !== '00' || i > 0)
      .join(':');
  }
  toggleAutoScroll() {
    UserConfState.toggleAutoScroll();
    this.autoscroll = UserConfState.getAutomaticScroll;
  }
  toggleTranscriptionsOptions() {
    this.showTranscriptOptions = !this.showTranscriptOptions;
  }
}
